import(/* webpackMode: "eager" */ "/vercel/path0/api-config/toaster.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/talent-profile/collapse.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/talent-profile/technical-skills.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/talent-profile/user-summary.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/legacy/image.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
